import { memo } from "react";
import { BzModal, BzModalBody, BzModalHeader } from '../../components';
import { Row, Col, Container } from "react-bootstrap";
import { useSelector,useDispatch } from "react-redux";
import {handleModal} from "../../redux/actions/modals"


const AboutUsModal = () => {

    const dispatch = useDispatch()

    const  aboutUs  = useSelector(state => state?.appInfo?.aboutUs);

    const modals = useSelector(state => state?.modals?.modals)

    const handleClose = ()=>{
      dispatch(handleModal([{"ABOUT_US_MODAL":false}]))
    }  

    return (
        <>
            <BzModal size='lg' show={modals['ABOUT_US_MODAL']} onHide={handleClose} className='modal-breeze-lg'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-self-center'>
                                <div className='font-medium font-size4 color-text'>About Us</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div data-testid={"modal-close"} onClick={handleClose} className='icon-16 icon-close icon-dark'></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                   <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-start'>
                                <div className='infodata' dangerouslySetInnerHTML={{ __html: aboutUs }}></div>
                            </Col>
                        </Row>
                    </Container>               
                </BzModalBody>
            </BzModal>


        </>
    );
};

export default memo(AboutUsModal);